import * as React from 'react';
import Popover from '@mui/material/Popover';
import { styled } from '@mui/material/styles';
import { ViewColumn, Web } from '@mui/icons-material';
import { Alert, IconButton, List, ListItem, ListItemIcon, ListItemText, Snackbar,  Tooltip } from '@mui/material';
import Service from '../../../util/Service';

const IB = styled(IconButton)(({ theme }) => ({
    borderRadius: 0,
}));

export default function LayoutPopover(props) {
    const { onSelect, code, refDiv, refreshEditor, element } = props;

    const [anchorEl, setAnchorEl] = React.useState(null);

    const [msg, setMsg] = React.useState();
    const [openSnack, setOpenSnack] = React.useState(false);
    const [clonedContent, setClonedContent] = React.useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    React.useEffect(() => {
        if (open) {
            const s = window.getSelection();
            if (s.rangeCount > 0 && checkValidEditor() ) {
                const range = s.getRangeAt(0);//s.baseNode;
                const cc = range.startContainer;//.cloneContents(); //extractContents();      
                setClonedContent(cc);
            }
        }
    }, [open]);

    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setMsg();
        setOpenSnack(false);
    };

    const checkValidEditor=()=>{
        const s = window.getSelection();
        if (s.rangeCount > 0) {
            const range = s.getRangeAt(0);//s.baseNode;
            const cc = range.startContainer;//.cloneContents(); //extractContents();      
            const pai = cc.parentNode;
            return( pai.id === "very2Editor")
        }
        return false;
    }
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleGridLayout = (tp) => {
        console.log(">>>handleGridLayout<<<", clonedContent);
        let htmlOld = null;
        if( clonedContent ){
            const remove = document.createElement('p');
            remove.setAttribute("id", "paraRemover");
            remove.textContent = "---";
            clonedContent.replaceWith(remove);
            htmlOld = refDiv.current.innerHTML;
        }else{
            htmlOld = refDiv.current.innerHTML;
        }
        let html = '';
        const el = document.getElementById("very2Editor");
        if (!el) {
            html = refDiv.current.innerHTML;
        } else {
            html = el.innerHTML;
        }
        
        const dado = {
            code: html,
            tipo: tp,
        }
        console.log( dado );
        
        Service.POST("/api/security/model/layout", dado).then(r => {
            console.log(r);
            if (r.success) {
                refDiv.current.innerHTML = r.dado;
                handleClose();
                refreshEditor();
            } else {
                // alert(r.msg);
                setMsg(r.msg);
                setOpenSnack(true);
                if( htmlOld){ //deu algum erro volta backup se existe
                    refDiv.current.innerHTML = htmlOld;
                }
            }
        })
    }
    return (
        <React.Fragment>
            <Tooltip title="Layout">
                <IB
                    color={'secundary'}
                    onClick={handleClick}
                    size="small"
                >
                    <Web />
                </IB>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }} dense={true}>
                    <ListItem sx={{ cursor: 'pointer' }} onClick={() => handleGridLayout('grid')}>
                        <ListItemIcon>
                            <IB>
                                <img width="24px" height="24px" src="/svg/layoutPagina.svg" />
                            </IB>
                        </ListItemIcon>
                        <ListItemText primary="Pagina" secondary="Layout Pagina" />
                    </ListItem>
                    <ListItem sx={{ cursor: 'pointer' }} onClick={() => handleGridLayout('2coluna')}>
                        <ListItemIcon>
                            <IB>
                                <img width="24px" height="24px" src="/svg/layoutGrid.svg" />
                            </IB>
                        </ListItemIcon>
                        <ListItemText primary="Grid" secondary="Layout Grid" />
                    </ListItem>
                    <ListItem sx={{ cursor: 'pointer' }} onClick={() => handleGridLayout('3coluna')}>
                        <ListItemIcon>
                            <IB>
                                <ViewColumn />
                            </IB>
                        </ListItemIcon>
                        <ListItemText primary="Grid" secondary="Layout Grid" />
                    </ListItem>
                </List>

            </Popover>
            <Snackbar open={openSnack} autoHideDuration={6000} onClose={handleCloseSnack}>
                <Alert
                    onClose={handleCloseSnack}
                    severity="success"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {msg}
                </Alert>
            </Snackbar>
        </React.Fragment>
    );
}
